<template>
  <div class="topArea pb-5">
      <!-- <div>{{ $t("message.hello") }}</div> -->
    <div class="text-center darker mt-5 fs-giant">{{ welcomeMessage }}</div>

    <div class="col-md-12 d-flex justify-content-center mt-3" :class="{'locked':locked}">

      <button type="button" class="btnFilter pointer border-0 dark fs-small py-1 px-3 bold"
      v-for="button in filterButtons"
      v-bind:class="{ active: feedFilter == button.term && locked == false}"
      v-on:click="filterChanged(button.term)">
        <i class="color-1 fs-small" :class="button.icon"></i>
        {{button.label}}
      </button>

    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
      data: function(){
        return{
          selectedFilter: ''
        }
      },
      props: {
        locked:{
          type: Boolean,
          default: false
        },
        filterButtons:{
          type: Array
        },
        feedFilter:{
          type: String
        }
      },
      computed: {
          ...mapGetters([
              'account',
          ]),
        welcomeMessage: function() {
          return 'Welcome back, ' + this.account.name;
        }
      },
      methods:{
        filterChanged(term) {
          if(!this.locked) {
            this.selectedFilter = term;
            this.$emit('filterChanged', this.selectedFilter);
          }
        }
      }
    }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .topArea{
    border-bottom: 1px solid $light;

    .locked{
      opacity: 0.5;

      *{
        cursor: default;
      }
    }

    .btnFilter{
      background: none;

      i{
        color: $color-1;
      }
    }

    .btnFilter.active{
      border-radius: 100px;
      background-color: $color-1;
      color: $lightest !important;
      font-weight: 400;


      i{color: $lightest !important;}
    }



  }

</style>



// WEBPACK FOOTER //
// FeedTop.vue?552939d7